import React from "react";
import img from "../../Assets/News&Blogs/image.png";
import img2 from "../../Assets/News&Blogs/image (1).png";
import img3 from "../../Assets/News&Blogs/image (2).png";
import img4 from "../../Assets/News&Blogs/image (3).png";
import img5 from "../../Assets/News&Blogs/image (4).png";
import img6 from "../../Assets/News&Blogs/image (5).png";
import img7 from "../../Assets/News&Blogs/image (6).png";
import img8 from "../../Assets/News&Blogs/image (7).png";
import { GoTag } from "react-icons/go";
import { FaRegCommentAlt } from "react-icons/fa";
import { CiUser } from "react-icons/ci";
import { useNavigate } from "react-router-dom";

const ImagesAndContent = () => {
  const navigate = useNavigate();
  const blogPosts = [
    {
      src: img,
      alt: "News image 1",
      title:
        "Contrary to popular belief , Lorem Ipsum is not simply random text.",
      certification: "Certification",
      user: "By Admin",
      comments: "65 Comments",
      date: "18 ",
      month: "NOV",
    },
    {
      src: img2,
      alt: "News image 2",
      title:
        "Contrary to popular belief , Lorem Ipsum is not simply random text.",
      certification: "Certification",
      user: "By Admin",
      comments: "65 Comments",
      date: "18 ",
      month: "NOV",
    },
    {
      src: img3,
      alt: "News image 3",
      title:
        "Contrary to popular belief , Lorem Ipsum is not simply random text.",
      certification: "Certification",
      user: "By Admin",
      comments: "65 Comments",
      date: "18 ",
      month: "NOV",
    },
    {
      src: img4,
      alt: "News image 4",
      title:
        "Contrary to popular belief , Lorem Ipsum is not simply random text.",
      certification: "Certification",
      user: "By Admin",
      comments: "65 Comments",
      date: "18 ",
      month: "NOV",
    },
    {
      src: img5,
      alt: "News image 5",
      title:
        "Contrary to popular belief , Lorem Ipsum is not simply random text.",
      certification: "Certification",
      user: "By Admin",
      comments: "65 Comments",
      date: "18 ",
      month: "NOV",
    },
    {
      src: img6,
      alt: "News image 6",
      title:
        "Contrary to popular belief , Lorem Ipsum is not simply random text.",
      certification: "Certification",
      user: "By Admin",
      comments: "65 Comments",
      date: "18 ",
      month: "NOV",
    },
    {
      src: img7,
      alt: "News image 7",
      title:
        "Contrary to popular belief , Lorem Ipsum is not simply random text.",
      certification: "Certification",
      user: "By Admin",
      comments: "65 Comments",
      date: "18 ",
      month: "NOV",
    },
    {
      src: img8,
      alt: "News image 8",
      title:
        "Contrary to popular belief , Lorem Ipsum is not simply random text.",
      certification: "Certification",
      user: "By Admin",
      comments: "65 Comments",
      date: "18 ",
      month: "NOV",
    },
  ];

  return (
    <div className="w-full p-4 md:p-8 lg:p-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {blogPosts.map((post, index) => (
          <div
            key={index}
            className="group overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-all duration-300 bg-white flex flex-col relative "
          >
            <div className="overflow-hidden">
              <img src={post.src} alt={post.alt} />
            </div>

            {/* date  */}
            <div className="absolute w-12 h-12 rounded-md top-40 lg:top-44 md:top-52 xl:top-52 left-4 text-center bg-white flex justify-center items-center flex-col">
              <p className="text-sm">{post.date}</p>
              <p className="text-xs text-gray-700">{post.month}</p>
            </div>

            <div className="text-[#4D4D4D] text-xs sm:text-sm md:text-xs xl:text-sm flex justify-center items-center gap-4 mt-4">
              <p className="flex gap-1">
                {" "}
                <span className="mt-1">
                  <GoTag />
                </span>
                {post.certification}
              </p>

              <p className="flex gap-1">
                <span className="mt-1">
                  <CiUser />
                </span>
                {post.user}
              </p>

              <p className="flex gap-1">
                {" "}
                <span className="mt-1">
                  <FaRegCommentAlt />
                </span>
                {post.comments}
              </p>
            </div>
            <div className="px-5">
              <h3 className="font-semibold text-lg text-[#1A1A1A] my-2 line-clamp-2 hover:text-[#00709F]">
                {post.title}
              </h3>
              <button
                onClick={() => {
                  navigate("/blogDetails");
                  window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });
                }}
                className="text-[#29AAE1] font-medium text-sm hover:text-blue-800 transition-colors flex items-center pb-2 cursor-pointer"
              >
                Read More ....
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImagesAndContent;
